<vw-modal class="z-[9999]" [width]="'94%'" [height]="'auto'" [closeIcon]="'fas fa-times-circle'" [showCloseIcon]="true"
  [isOpen]="isOpen" (close)="close()" [customClasses]="'rounded-lg border shadow-xl'">
  <div modalHeader>
    <div class="w-full flex ">
      <div class="flex w-full">
        <vw-circle-user-icon></vw-circle-user-icon>
        <div class="ml-2">
          <h2 class="text-[#0C0D0D] text-md font-semibold truncate pr-4">
            {{ 'common.modals.report.title' | translate }}
          </h2>
          <span class="text-gray-500 text-sm "> {{ 'common.modals.report.subtitle' | translate }}</span>
        </div>
      </div>
      <vw-close-btn (click)="close()"></vw-close-btn>
    </div>
  </div>

  <div modalBody>
    <div class="flex w-full pt-2">
      <vw-message-icon></vw-message-icon>
      <div class="ml-2">
        <h2 class="text-[#0C0D0D] text-md font-semibold truncate">
          {{ 'common.modals.report.question' | translate }}
        </h2>
        <span class="text-gray-500 text-sm pt-2 ">
          {{ 'common.modals.report.description' | translate }}
        </span>

        <div class="pt-2">
          <!-- "choices": {
          "wrong": "Une information erronée",
          "missing": "Une information manquante",
          "inappropriate": "Un contenu inapproprié",
          "other": "Autre chose"
        } -->
          @for (choice of choices; track choice) {
            <vw-button [label]="'common.modals.report.choices.' + choice | translate"
                       [look]="selectedChoice === choice ? 'primary' : 'clear'" [size]="'small'" customClass="mb-2"
                       (click)="onChoiceSelected(choice)" />
          }
        </div>
      </div>
    </div>
    <!--message-->
    <h2 class="text-[#0C0D0D] text-md font-semibold truncate ml-8">
      {{ 'common.modals.report.message.label' | translate }}
    </h2>
    <div class="flex bg-gray-100 rounded-xl items-center justify-between pr-4 mt-2 ml-8">
      <input type="text"
        class="bg-transparent outline-none w-full placeholder:text-[#475569] placeholder:text-sm py-4 px-5"
        placeholder="{{ 'common.modals.report.message.placeholder' | translate }}" [(ngModel)]="message">
      <button class="bg-transparent rounded-full size-9 shrink-0 cursor-pointer flex items-center justify-center"
        (click)="onSendButtonClick()">
        <vw-icon-svg iconUrl="/assets/svg/send.svg" width="24px" height="24px"></vw-icon-svg>
      </button>
    </div>
  </div>
</vw-modal>
